import { type FC, memo } from 'react';

import type { Props } from '@/components/SessionAttendanceChips/types';
import { pillColorClasses } from '@/ui/lib/colorSchemes';
import { cn } from '@/ui/lib/utils';

const SessionAttendanceChips: FC<Props> = ({
  className,
  disabled,
  label,
  onChange,
  selectedIds,
  sessions
}) => {
  const toggle = (id: string) => {
    onChange(selectedIds.includes(id) ? selectedIds.filter((s) => s !== id) : [...selectedIds, id]);
  };

  return (
    <div className={className}>
      {label && <div className="mb-1.5">{label}</div>}
      <div className="flex flex-wrap gap-2">
        {sessions.map((session) => {
          const selected = selectedIds.includes(session.id);
          return (
            <button
              key={session.id}
              type="button"
              disabled={disabled}
              aria-pressed={selected}
              onClick={() => toggle(session.id)}
              className={cn(
                'inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-sm font-medium transition-colors',
                'disabled:pointer-events-none disabled:opacity-50',
                selected
                  ? cn('border-transparent', pillColorClasses.secondary.filled)
                  : 'border-dashed border-uniform-gray-300 text-uniform-gray-500 dark:border-uniform-gray-600 dark:text-uniform-gray-400'
              )}>
              {session.label}
              {session.startsOn && (
                <span className="text-xs opacity-70">· from {session.startsOn}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default memo(SessionAttendanceChips);
